import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithHidden } from '~/core/styleTypes';

export const AdditionalTeamInfo = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: row;
    height: 17px;
    color: ${({ theme }) => theme.Text.secondary};
    align-items: center;
`;

export const TeamName = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle2}
    display: flex;
    height: 16px;
    align-items: center;
    line-height: unset;
`;

export const TeamOddsContainer = styled.div<WithHidden>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
    height: 34px;
    text-align: right;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const TeamScore = styled.div<WithHidden>`
    ${BaseStyle.Mixins.fontStyles.ui['24b']}
    display: ${({ $isHidden }) => ($isHidden ? 'none' : 'initial')};
    width: 100%;
    max-width: 50px;
    height: 34px;
    text-align: right;
    color: ${({ theme }) => theme.Text.primary};
    padding-top: 6px;
`;

export const TeamContainer = styled.div`
    display: flex;
    height: 34px;
    justify-content: space-between;
`;

export const TeamLogo = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['48m']}
    height: 34px;
    display: flex;
    justify-content: center;
`;

export const TeamInfoContainer = styled.div<{ $centerJustify: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    display: flex;
    flex-direction: column;
    justify-content: ${({ $centerJustify }) => ($centerJustify ? 'center' : 'space-between')};
    width: 100%;
    padding-left: 7px;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const TeamGameDetails = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
`;
